module.exports = __webpack_public_path__ + "img/oslona-dolna-zderzaka-tylnego.c294b350.jpg";